/*
*
*  Push Notifications codelab
*  Copyright 2015 Google Inc. All rights reserved.
*
*  Licensed under the Apache License, Version 2.0 (the "License");
*  you may not use this file except in compliance with the License.
*  You may obtain a copy of the License at
*
*      https://www.apache.org/licenses/LICENSE-2.0
*
*  Unless required by applicable law or agreed to in writing, software
*  distributed under the License is distributed on an "AS IS" BASIS,
*  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
*  See the License for the specific language governing permissions and
*  limitations under the License
*
*/

/* eslint-env browser, es6 */
/* eslint-disable no-console */

'use strict';

import Store from './store'
import { Message, Notice } from 'iview'
import { register } from 'register-service-worker'
var pjson = require('@/../package.json');

import firebase from 'firebase/app';
require('firebase/messaging');

const fireApiKey = process.env.VUE_APP_FIRE_API_KEY;
const fireProjectId = process.env.VUE_APP_FIRE_PROJECT_ID;
const fireMessagingSenderId = process.env.VUE_APP_FIRE_MESSAGING_SENDER_ID;
const fireAppId = process.env.VUE_APP_FIRE_APP_ID;
const fireVapidKey = process.env.VUE_APP_FIRE_VAPID_KEY;

const pushButton = document.querySelector('#PUSHNOTIF');
let messaging = null;

window.signout = false

firebase.initializeApp({
  'apiKey': fireApiKey,
  'projectId': fireProjectId,
  'messagingSenderId': fireMessagingSenderId,
  'appId': fireAppId
});


const firebaseService = {
  initializeFirebase() {
    messaging = firebase.messaging();
    messaging.usePublicVapidKey(fireVapidKey);

    messaging.onTokenRefresh(() => {
      messaging.getToken().then((refreshedToken) => {
        window.localStorage.setItem("notification_enabled", true)
        firebaseService.registerToken(refreshedToken)
        firebaseService.updateNotificationStatus(refreshedToken)
        console.log("[Firebase] Refresh Token :", refreshedToken)
      }).catch((err) => {
        window.localStorage.setItem("notification_enabled", false)
        firebaseService.updateNotificationStatus(null)
        console.error("[Firebase] Error:", err)
      });
    });
  },
  initializeButton() {
    pushButton.addEventListener("click", (e) => {
      Store.commit('base/setLoadingPage', true);
      messaging
        .requestPermission()
        .then(function () {
          return messaging.getToken();
        }).then((token) => {
          if (token) {
            if (window.localStorage.getItem("notification_enabled") !== "true") {
              Message.success('Successfully saved')
              Store.commit('base/setLoadingPage', false);
              firebaseService.registerToken(token)
              window.localStorage.setItem("notification_enabled", true)
              firebaseService.updateNotificationStatus(token)
              console.log("[Firebase] Token :", token)
            }
            else {
              messaging.deleteToken(token)
                .then((success) => {
                  window.localStorage.setItem("notification_enabled", false)
                  firebaseService.updateNotificationStatus(null)
                  if (!window.signout)
                    Message.success('Successfully saved')
                  window.signout = false
                  console.log("[Firebase] Delete Successful :", success)
                })
                .finally(() => {
                  Store.commit('base/setLoadingPage', false);
                })
            }
          }
        }).catch(function (err) {
          window.localStorage.setItem("notification_enabled", false)
          firebaseService.updateNotificationStatus(null)
          console.error("[Firebase] Error:", err)
        })
        .finally(() => {
          Store.commit('base/setLoadingPage', false);
        });
    })
  },
  registerToken(token) {
    Store.dispatch('pushRegisterDevice', token);
    Store.commit('setnotifSubscription', token)
  },
  updateNotificationStatus(token) {
    if (Notification.permission === 'denied') {
      pushButton.textContent = 'Push Messaging Blocked.';
      pushButton.disabled = true;
      Store.commit('setPushSupport', false);
      Store.commit('setEnableNotifButton', false);
      Message.info('Push notification is not supported on your device.')
      return;
    }

    if (JSON.parse(window.localStorage.getItem("notification_enabled")) == true) {
      pushButton.textContent = 'Disable Push';
    } else {
      pushButton.textContent = 'Enable Push';
    }

    Store.commit('setPushSupport', true);
    pushButton.disabled = false;
    Store.commit('setnotifSubscription', token)
    Store.commit('setEnableNotifButton', true);
  }
}

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered(registration) {
      console.log('SW Registered', registration)
      firebaseService.initializeFirebase()
      messaging.useServiceWorker(registration)
      firebaseService.updateNotificationStatus(null)
      firebaseService.initializeButton()
    },
    cached(registration) {
      console.log('SW Cached', registration)
    },
    updated(registration) {
      console.log('SW Updated', registration)
    },
    offline() {
      console.log('SW No internet connection found. App is running in offline mode.')
      Store.commit('base/setOnlineStatus', false);
      Store.commit('setEnableNotifButton', false);
    },
    error(error) {
      Store.commit('setEnableNotifButton', false);
      console.error('Error during service worker registration:', error)
    }
  })
}
